import React from 'react';
import { useParams } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { ModelForm } from '../components';

export default function Vendor({ formMode }) {
	const { id } = useParams();
	return (
		<Grid container>
			<ModelForm
				recordId={id}
				formName={'createVendorForm'}
				initialMode={formMode}
			/>
		</Grid>
	);
}
